"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeAuthFeatureFlags = exports.AuthFeatureFlagsUpdateSchema = exports.DEFAULT_AUTH_FEATURE_FLAGS = exports.AuthFeatureFlagsSchema = void 0;
var zod_1 = require("zod");
exports.AuthFeatureFlagsSchema = zod_1.z.object({
    skipLogin2FA: zod_1.z.boolean().default(false),
});
exports.DEFAULT_AUTH_FEATURE_FLAGS = {
    skipLogin2FA: false,
};
exports.AuthFeatureFlagsUpdateSchema = exports.AuthFeatureFlagsSchema;
var mergeAuthFeatureFlags = function (flags) { return ({
    skipLogin2FA: typeof (flags === null || flags === void 0 ? void 0 : flags.skipLogin2FA) === 'boolean' ? flags.skipLogin2FA : exports.DEFAULT_AUTH_FEATURE_FLAGS.skipLogin2FA,
}); };
exports.mergeAuthFeatureFlags = mergeAuthFeatureFlags;
//# sourceMappingURL=authFeatureFlags.js.map